import React from 'react';

// Icon components - using actual SVG files from public/icons
export const GitHubIcon = ({ size = 24 }) => (
  <img src="/icons/github-svgrepo-com.svg" alt="GitHub" width={size} height={size} />
);

export const MediumIcon = ({ size = 24 }) => (
  <img src="/icons/medium-svgrepo-com.svg" alt="Medium" width={size} height={size} />
);

export const LinkedInIcon = ({ size = 24 }) => (
  <img src="/icons/linkedin-svgrepo-com.svg" alt="LinkedIn" width={size} height={size} />
);

export const InstagramIcon = ({ size = 24 }) => (
  <img src="/icons/instagram-svgrepo-com.svg" alt="Instagram" width={size} height={size} />
);
